import { jsx as _jsx } from "react/jsx-runtime";
import './style.css';
var StatusModifier = function (props) {
    // Match Stitch: primary CTA spans full width; danger/warning stay compact chips
    var toneClass = {
        pending: 'tone-muted',
        un_reached: 'tone-muted',
        confirmed: 'tone-success',
        waiting: 'tone-warning',
        in_visit: 'tone-primary',
        after_work: 'tone-muted',
        finished: 'tone-primary',
        cancelled: 'tone-danger',
        postpone: 'tone-muted',
    };
    return (_jsx("button", { type: "button", className: "stitch-status-btn ".concat(toneClass[props.status] || 'tone-muted'), onClick: function () { return props.onPress(); }, children: props.title }));
};
export default StatusModifier;
